<script>
    import VBtn from "vuetify/es5/components/VBtn/";
    export default {
        extends: VBtn,
        props: {
            color: {
                default: 'primary'
            },
            borderRadius: 0
        }
    }
</script>